import type { NetworkData } from '@dynamic-labs-sdk/client';
import type { Commitment, ConnectionConfig } from '@solana/web3.js';
import { Connection } from '@solana/web3.js';

type GetSolanaConnectionOptions = {
  commitmentOrConfig?: Commitment | ConnectionConfig;
  networkData: NetworkData;
};

/**
 * Returns a new Solana connection for the given network provider.
 *
 * @example
 * ```ts
 * import { getActiveNetworkData } from '@dynamic-labs-sdk/client';
 * import { isSolanaNetworkProvider, getSolanaConnection } from '@dynamic-labs-sdk/solana';
 *
 * const { networkData } = getActiveNetworkData({ walletAccount });
 *
 * if(!networkData) {
 *   throw new Error('No network data found');
 * }
 *
 * const connection = getSolanaConnection({
 *   networkData,
 * });
 * ```
 */
export const getSolanaConnection = ({
  networkData,
  commitmentOrConfig,
}: GetSolanaConnectionOptions) => {
  return new Connection(networkData.rpcUrls.http[0], commitmentOrConfig);
};
